import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil, timer } from 'rxjs';
import axios from 'src/app/Service/axios';
import * as L from 'leaflet';

@Component({
  selector: 'app-load-watch-dashboard',
  templateUrl: './load-watch-dashboard.component.html',
  styleUrls: ['./load-watch-dashboard.component.css'],
})

export class LoadWatchDashboardComponent implements OnInit {
  private mapInstance: L.Map | undefined;
  private markerInstance: L.Marker | null = null;
  private destroy$ = new Subject<void>();

  loadWatch: any = {};

  searchForm: FormGroup = this._formBuilder.group({
    strSession: new FormControl(this._gurd.decrypt(localStorage.getItem('Session')!)),
    iSystemUser: new FormControl(this._gurd.decrypt(localStorage.getItem('ID')!)),
    strIMEI: new FormControl('')
  });

  constructor(
    private _tooltip: NotificationService,
    private _formBuilder: FormBuilder,
    private _gurd: GurdServiceService,
    public _other: OtherService,
    private _router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const id = this.route.snapshot.parent?.params['id'];

    this.searchForm.patchValue({
      strIMEI: id
    })

    timer(0, 30000).pipe(takeUntil(this.destroy$)).subscribe(
      () => this.fetchData(false)
    );

  }

  ngOnDestroy(): void {
    if (this.mapInstance) {
      this.mapInstance.remove();
    }
    this.stopTimer();
  }

  stopTimer() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  fetchData = async (showLoading: boolean = true) => {
    let model = this.searchForm.value;

    if (showLoading) {
      this._other.Showspinner()
    }

    let res = JSON.parse((await axios.post(`LoadWatch_Telemetry_LastValue`, this._other.stringNumberToNumber(model))).data.toString());
    this._other.nonespinner();

    if (res.ISSessionExpired == true) {
      this._tooltip.showError('لطفا وارد سیستم شوید');
      this._other.removeLocalStorage();
      this._router.navigate(['login'], { queryParams: { error: '3' } });
      return;
    }

    if (res.iResult == 0) {
      return this._tooltip.showError(res.strError);
    }

    this.loadWatch = res[0];
    this.initMap();

  }

  private initMap(): void {
    if (this.mapInstance) {
      this.mapInstance.remove();
    }

    this.mapInstance = L.map('generator-map', {
      center: [35.6892, 51.3890],
      zoom: 13,
      zoomControl: true,
      attributionControl: true
    });

    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
      // attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; CartoDB',
      subdomains: 'abcd',
      maxZoom: 19,
      minZoom: 6
    }).addTo(this.mapInstance);

    this.updateMap(this.loadWatch)
  }

  public updateMap(data: any): void {
    if (!this.mapInstance) return;

    const lat = data.fLat;
    const lng = data.fLon;
    const name = data.strName;
    const isOnline = data.strGeneratorStatus === 'روشن';

    if (!lat || !lng) {
      if (this.markerInstance) {
        this.mapInstance.removeLayer(this.markerInstance);
        this.markerInstance = null;
      }
      return;
    }

    const color = isOnline ? '#4caf50' : '#ef5350';

    const icon = L.divIcon({
      html: `<div style="background:${color}; width:32px; height:32px; border-radius:50%; display:flex; align-items:center; justify-content:center; font-size:16px; color:#fff; border:3px solid #fff; box-shadow: 0 0 20px ${color}88;">
              <i class="fa fa-bolt"></i>
             </div>`,
      className: '',
      iconSize: [32, 32],
      iconAnchor: [16, 16]
    });

    if (this.markerInstance) {
      this.mapInstance.removeLayer(this.markerInstance);
    }

    this.markerInstance = L.marker([lat, lng], { icon: icon, title: name })
      .bindPopup(`
          <div style="font-family:'vazir',sans-serif; direction:rtl; text-align:right; padding:4px 0;">
              <div style="font-size:13px; color:#b0bec5;">
                  <span style="color:${color};">●</span> ${isOnline ? 'در حال کار' : 'خاموش'}
              </div>
              <div style="font-size:12px; color:#78909c; margin-top:4px;">
                  ${lat.toFixed(6)}, ${lng.toFixed(6)}
              </div>
          </div>
      `)
      .addTo(this.mapInstance);

    this.mapInstance.setView([lat, lng], 14);
    // this.markerInstance.openPopup();
  }

  getImbalanceStatus(value: number): string {
    if (value == null || value < 0) {
      return '';
    }

    if (value <= 5) {
      return 'نرمال';
    } else if (value <= 10) {
      return 'هشدار';
    } else if (value <= 15) {
      return 'نامطلوب';
    } else {
      return 'بحرانی';
    }
  }

}
